import audioCore from '@resn/gozer-audio';
import createAudioObject from '@resn/gozer-audio/create-audio-object';

const loadArrayBuffer = (url) => fetch(url).then((r) => r.arrayBuffer());

export default (url) =>
    new Promise((resolve, reject) => {
        try {
            const { context } = audioCore;
            const arrayBufferPromise = loadArrayBuffer(url);

            arrayBufferPromise.then((arrayBuffer) => {
                const audioBufferPromise = new Promise((resolve, reject) =>
                    context.decodeAudioData(arrayBuffer, resolve, reject),
                );

                audioBufferPromise.then((audioBuffer) => {
                    resolve(createAudioObject(audioBuffer));
                });
            });
        } catch (e) {
            reject(e);
        }
    });
